<template>
  <header class="header header--6">
    <div class="container">
      <div class="navbar">
        <navbar-logo></navbar-logo>
        <nav class="top-navbar">
          <top-nav :bookPortal="bookPortal"></top-nav>
          <login-btn></login-btn>
          <button
            v-if="isAuth"
            class="btn btn-menu btn-menu-desktop d-none d-xl-flex"
            @click="toggleMenu">
            <span></span>
            <span></span>
          </button>
          <button
            class="btn btn-menu btn-menu-mobile d-xl-none"
            @click="toggleMobileMenu">
            <span></span>
            <span></span>
          </button>
        </nav>
        <nav
          v-if="isAuth"
          class="main-navbar d-none d-xl-block">
          <main-nav></main-nav>
        </nav>
        <nav class="mobile-navbar d-xl-none">
          <mobile-nav></mobile-nav>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
  import { useAuthStore } from "@/stores";
  import NavbarLogo from "./parts/NavbarLogo.vue";
  import TopNav from "./parts/TopNav.vue";
  import LoginBtn from "./parts/LoginBtn.vue";
  import MainNav from "./parts/MainNav.vue";
  import MobileNav from "./parts/MobileNav.vue";

  export default {
    props: {
      bookPortal: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        authStore: useAuthStore(),
      };
    },
    components: {
      NavbarLogo,
      TopNav,
      LoginBtn,
      MainNav,
      MobileNav
    },
    computed: {
      isAuth() {
        return this.authStore.isAuth;
      },
    },
    methods: {
      toggleMenu() {
        const navbar = document.querySelector(".main-navbar");
        const btn = document.querySelector(".btn-menu-desktop");
        navbar.classList.toggle("open");
        btn.classList.toggle("open");
      },
      toggleMobileMenu() {
        const navbar = document.querySelector(".mobile-navbar");
        const btn = document.querySelector(".btn-menu-mobile");
        navbar.classList.toggle("open");
        btn.classList.toggle("open");
      }
    },
  };
</script>

<style lang="scss">
  .header--6 {
    &.header {
      position: relative;
      .navbar {
        padding: 20px 60px;
        background: $main-light;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        position: relative;
      }
      .top-navbar {
        display: flex;
        justify-content: flex-end;
        gap: 60px;
      }
      .main-navbar {
        position: absolute;
        left: 0;
        top: -100%;
        width: 100%;
        padding: 20px 60px;
        background: $main-light;
        z-index: 2;
        transition: $transition;
        &.open {
          top: 100%;
        }
      }
      .menu {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 60px;
        li {
          a {
            padding: 2px 4px;
            color: $main-dark;
            transition: $transition;
            &:hover {
              background: $main-dark;
              color: $main-light;
            }
          }
        }
      }
      .btn-menu {
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 20px 0 0;
        span {
          display: block;
          width: 20px;
          height: 2px;
          background: $main-dark;
          margin: 4px 0;
          transition: $transition;
        }
        &.open {
          span {
            &:nth-child(1) {
              transform: rotate(45deg) translate(3px, 3px);
            }
            &:nth-child(2) {
              transform: rotate(-45deg) translate(4px, -4px);
            }
          }
        }
        &:focus {
          outline: none;
        }
      }
      @media (max-width: $breakpoint-xl) {
        .navbar {
          padding: 12px 16px;
          &__logo {
            width: 98px;
            height: 18px;
            img {
              object-fit: contain;
            }
          }
        }
        .mobile-navbar {
          position: absolute;
          top: calc(100% + 1px);
          left: 0;
          top: -2000%;
          width: 100%;
          padding: 12px 16px;
          background: $main-light;
          z-index: 100;
          transition: $transition;
          &.open {
            top: 100%;
          }
        }
        .menu {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          gap: 16px; 
          margin-bottom: 16px;
        }
      }
    }
  }
</style>
